import React, { memo } from 'react';

interface GroupVisualFeedbackProps {
  isExiting: boolean;
  exitProgress: number;
  direction: 'none' | 'left' | 'right' | 'top' | 'bottom';
  isResizing: boolean;
  isSelected: boolean;
  color: string;
}

const GroupVisualFeedback: React.FC<GroupVisualFeedbackProps> = memo(({
  isExiting,
  exitProgress,
  direction,
  isResizing,
  isSelected,
  color,
}) => {
  const opacity = isExiting ? Math.max(0.4, 1 - exitProgress * 0.6) : 1;

  return (
    <>
      {isExiting && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: 8,
            border: `2px dashed rgba(244, 63, 94, ${0.3 + exitProgress * 0.5})`,
            pointerEvents: 'none',
            zIndex: 50,
            animation: 'groupExitPulse 0.8s ease-in-out infinite',
          }}
        />
      )}

      {isResizing && (
        <div
          style={{
            position: 'absolute',
            inset: -2,
            borderRadius: 10,
            border: `1px solid ${color}`,
            pointerEvents: 'none',
            zIndex: 49,
            opacity: 0.6,
          }}
        />
      )}

      {isSelected && !isExiting && (
        <div
          style={{
            position: 'absolute',
            inset: -1,
            borderRadius: 9,
            border: '1px solid rgba(255,255,255,0.3)',
            pointerEvents: 'none',
            zIndex: 48,
            opacity,
          }}
        />
      )}

      {isExiting && direction !== 'none' && (
        <div
          style={{
            position: 'absolute',
            top: direction === 'bottom' ? -20 : direction === 'top' ? undefined : '50%',
            bottom: direction === 'top' ? -20 : undefined,
            left: direction === 'right' ? -20 : direction === 'left' ? undefined : '50%',
            right: direction === 'left' ? -20 : undefined,
            transform: direction === 'left' || direction === 'right' ? 'translateY(-50%)' : 'translateX(-50%)',
            background: 'rgba(244, 63, 94, 0.8)',
            color: 'white',
            fontSize: 10,
            padding: '2px 6px',
            borderRadius: 4,
            pointerEvents: 'none',
            zIndex: 51,
            whiteSpace: 'nowrap',
          }}
        >
          释放以移出
        </div>
      )}
    </>
  );
});

GroupVisualFeedback.displayName = 'GroupVisualFeedback';

export default GroupVisualFeedback;
